<main class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    <section hlmCard aria-labelledby="partner-set-password-title">
      <div hlmCardHeader>
        <h1 hlmCardTitle id="partner-set-password-title">Passwort für den Partnerbereich</h1>
        <p hlmCardDescription>Mit diesem Passwort meldest du dich künftig im Partnerbereich an.</p>
      </div>

      <div hlmCardContent class="space-y-6">
        <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-6" novalidate>
          <div hlmField>
            <label hlmFieldLabel for="partner-new-password">Neues Passwort</label>
            <hlm-input-group class="w-full">
              <input
                hlmInputGroupInput
                id="partner-new-password"
                [type]="showPassword() ? 'text' : 'password'"
                formControlName="password"
                autocomplete="new-password"
                [attr.aria-invalid]="passwordInvalid ? 'true' : null" />
              <hlm-input-group-addon align="inline-end">
                <button
                  hlmInputGroupButton
                  type="button"
                  [attr.aria-label]="showPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
                  (click)="showPassword.set(!showPassword())">
                  <ng-icon [name]="showPassword() ? 'lucideEyeOff' : 'lucideEye'" />
                </button>
              </hlm-input-group-addon>
            </hlm-input-group>
            <p hlmFieldDescription [class.text-destructive]="passwordInvalid">
              Mindestens {{ minLength }} Zeichen.
            </p>
          </div>

          <div hlmField>
            <label hlmFieldLabel for="partner-confirm-password">Passwort bestätigen</label>
            <hlm-input-group class="w-full">
              <input
                hlmInputGroupInput
                id="partner-confirm-password"
                [type]="showPassword() ? 'text' : 'password'"
                formControlName="confirm"
                autocomplete="new-password"
                [attr.aria-invalid]="confirmInvalid ? 'true' : null" />
            </hlm-input-group>
            @if (confirmInvalid) {
              <p hlmFieldDescription class="text-destructive">
                Die Passwörter stimmen nicht überein.
              </p>
            }
          </div>

          @if (error()) {
            <div hlmAlert variant="destructive" role="alert">
              <ng-icon name="lucideTriangleAlert" />
              <p hlmAlertTitle>{{ error() }}</p>
              <p hlmAlertDescription>
                <a routerLink="/partner/login" class="underline underline-offset-4">
                  Neuen Link anfordern
                </a>
              </p>
            </div>
          }

          <button
            hlmBtn
            type="submit"
            class="w-full"
            [disabled]="loading() || !token"
            [attr.aria-busy]="loading()">
            @if (loading()) {
              <hlm-spinner />
              Wird gespeichert…
            } @else {
              Passwort festlegen
            }
          </button>
        </form>
      </div>
    </section>
  </div>
</main>
